import { createSelector } from 'reselect';

import { get as _get } from 'lodash';

import { selectFirestore, selectListPendingFactory, selectItemPendingFactory } from 'services/selectors';

import { utils as uploaderUtils } from 'modules/uploader';

const selectMapsState = state => state.maps;

const selectPending = createSelector(selectMapsState, maps => maps.pending);

const selectMap = createSelector(selectMapsState, maps => maps.map);

export const selectMapActivePinId = createSelector(selectMap, map => map.activePinId);

export const selectListPending = selectListPendingFactory(selectPending);
export const selectItemPending = selectItemPendingFactory(selectPending);

export const selectImageMaps = createSelector(selectFirestore, firestore => _get(firestore, 'ordered.imageMaps', []));

export const selectUploaderImageMaps = createSelector(selectImageMaps, imageMaps =>
    imageMaps.map(({ id, image, order }) => ({
        ...uploaderUtils.imageToFile(image),
        order,
        firestoreId: id,
    })),
);
